import { Component, OnInit } from '@angular/core';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { UserService } from 'src/modules/user.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { config } from 'src/config/config';
import { getEnv } from 'src/modules/utility';
import { cgpAuthentication } from 'src/modules/cgp-authentication';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

@Component({
   selector: 'request-access-form',
   templateUrl: './request-access-form.component.html',
})
export class RequestAccessFormComponent implements OnInit {

   disabled = false;
   loading = false;
   private loggedInUser;
   reason = new UntypedFormControl('', [Validators.required, Validators.maxLength(128)]);
   constructor(
      private readonly toastr: ToastrService,
      private readonly baseHttpService: BaseHttpService,
   ) { }

   ngOnInit() {
      this.loggedInUser = cgpAuthentication.getUserInfo();
      if (!this.loggedInUser) {
         this.disabled = true;
         this.toastr.error('The application could not load your user information properly. Please reload your webpage.', 'User Profile Unavailable');
      }
   }

   onSubmitClick() {
      this.loading = true;
      const gmin = this.loggedInUser.gmuniqueidentifier ? this.loggedInUser.gmuniqueidentifier : '';
      const url = `${config.tprecmApiBaseUrl[getEnv()]}login/request-access`;
      const body = {
         gmin: gmin,
         reason: this.reason.value
      };
      this.baseHttpService.post(url, body)
         .pipe(finalize(() => this.loading = false))
         .subscribe(() => {
            this.toastr.success('Your request to access TPRECM has been sent.', 'Access Request Successful');
         });
   }

}
